// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"3045": "e5b33855","4777": "13f44d2c","4779": "25e50ce7","5213": "51f45f08","5451": "9b02ad1a","631": "99e9e1d9","8735": "0a49cdea",}[chunkId] + ".css"
}